import { VendorFinancialsAdmin } from '../../../components/Vendor';

export function Financials() {
  return <VendorFinancialsAdmin />;
}
